"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaPropertyWrapper$ = exports.AreaPropertyWrapper$outboundSchema = exports.AreaPropertyWrapper$inboundSchema = void 0;
exports.areaPropertyWrapperToJSON = areaPropertyWrapperToJSON;
exports.areaPropertyWrapperFromJSON = areaPropertyWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const multipleproperty_js_1 = require("./multipleproperty.js");
/** @internal */
exports.AreaPropertyWrapper$inboundSchema = z.object({
    attributes: multipleproperty_js_1.MultipleProperty$inboundSchema,
    id: z.string(),
    type: z.literal("property").default("property").optional(),
});
/** @internal */
exports.AreaPropertyWrapper$outboundSchema = z.object({
    attributes: multipleproperty_js_1.MultipleProperty$outboundSchema,
    id: z.string(),
    type: z.literal("property").default("property"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaPropertyWrapper$;
(function (AreaPropertyWrapper$) {
    /** @deprecated use `AreaPropertyWrapper$inboundSchema` instead. */
    AreaPropertyWrapper$.inboundSchema = exports.AreaPropertyWrapper$inboundSchema;
    /** @deprecated use `AreaPropertyWrapper$outboundSchema` instead. */
    AreaPropertyWrapper$.outboundSchema = exports.AreaPropertyWrapper$outboundSchema;
})(AreaPropertyWrapper$ || (exports.AreaPropertyWrapper$ = AreaPropertyWrapper$ = {}));
function areaPropertyWrapperToJSON(areaPropertyWrapper) {
    return JSON.stringify(exports.AreaPropertyWrapper$outboundSchema.parse(areaPropertyWrapper));
}
function areaPropertyWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaPropertyWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaPropertyWrapper' from JSON`);
}
//# sourceMappingURL=areapropertywrapper.js.map